module.exports = __webpack_public_path__ + "img/shop-style-filter-red.8bb2eac3.png";